module.exports = __webpack_public_path__ + "6df7b9dc1a1c0120fa055b63a5c16582.jpg";